import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {GlobalLoaderService} from '../../services/global-loader.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ApiAgentService} from '../../services/api-agent.service';
import {Router, RouterModule} from '@angular/router';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {CommonModule} from '@angular/common';

declare var $: any;

interface SubAccountOtpResponse {
  merchantId: any;
  merchantName: any;
  merchantAccount: any;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, TranslateModule, RouterModule],
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loading: boolean;
  serverMsg: string;
  loginForm: FormGroup;
  submitted: boolean;
  otpPhase: boolean;
  mainMerchantsList: SubAccountOtpResponse[]; // [{"merchantId":"152","merchantName":"حسن عبدالاحد ياسين ايوب"}]
  @ViewChild('password') password: ElementRef;
  @ViewChild('otp') otp: ElementRef;
  isSubAccount: boolean;

  constructor(private loader: GlobalLoaderService,
              private translate: TranslateService,
              private formBuilder: FormBuilder,
              private router: Router,
              private api: ApiAgentService) {

  }

  ngOnInit() {
    this.isSubAccount = false;
    this.loginForm = this.formBuilder.group({
      mobile: ['', [Validators.required]],
      password: ['', [Validators.required]],
      otp: ['', [Validators.required]],
      mainMerchantId: ['']
    });
    this.loading = false;
  }

  // @ts-ignore
  get f() {
    return this.loginForm.controls;
  }

  next($event) {
    $event.preventDefault();
    if (this.loading == false) {
      this.loading = true;
      if (this.isSubAccount) {
        this.api.getSubOtp(this.loginForm.value['mobile'])
          .then(value => {
            console.log(value);
            this.otpPhase = true;
            this.mainMerchantsList = value;
          })
          .catch(reason => {
            this.otpPhase = false;
          }).finally(() => {
          this.loading = false;
        });
      } else {
        this.api.getOtp(this.loginForm.value['mobile'])
          .then(value => {
            console.log(value);
            this.otpPhase = true;
          })
          .catch(reason => {
            this.otpPhase = false;
          }).finally(() => {
          this.loading = false;
        });
      }
    }
  }

  login($event) {
    this.submitted = true;
    if (this.loginForm.valid) {
      $event.preventDefault();
      if (this.loading == false) {
        this.loading = true;
        sessionStorage.removeItem('myBusiness');
        this.api.login(this.loginForm.value['mobile'], this.loginForm.value['password'], this.loginForm.value['otp'], this.loginForm.value['mainMerchantId'], this.isSubAccount)
          .then(value => {
            console.log('login value', value);
            localStorage.setItem('token', value.id_token);
            this.router.navigate(['/']);
          })
          .catch(reason => {
            console.log('login fail', reason);
            this.translate.get('Could not login. Username or password may be incorrect.')
              .subscribe((value) => this.serverMsg = value, (error) => this.serverMsg = 'Could not login. Username or password may be incorrect.');
          }).finally(() => {
          this.loading = false;
        });
      }
    }
  }

  togglePassword() {
    this.password.nativeElement.type = this.password.nativeElement.type == 'password' ? 'text' : 'password';
  }

  toggleOtp() {
    this.otp.nativeElement.type = this.otp.nativeElement.type == 'password' ? 'text' : 'password';
  }

  toggleSubAccount() {
    this.isSubAccount = !this.isSubAccount;
  }
}
